import { z } from 'zod';
import { idSchema, isoDateTime, okSchema } from './common.js';
export const loginRequestSchema = z.object({
    password: z.string().min(1).max(512),
});
export const meSchema = z.object({
    user: z.object({ id: idSchema, label: z.string() }),
    sessionId: idSchema,
});
export const sessionSummarySchema = z.object({
    id: idSchema,
    issuedAt: isoDateTime,
    lastSeenAt: isoDateTime,
    expiresAt: isoDateTime,
    userAgent: z.string().nullable(),
    current: z.boolean(),
});
export const sessionListSchema = z.object({ sessions: z.array(sessionSummarySchema) });
export const logoutResponseSchema = okSchema;
export const passkeySummarySchema = z.object({
    id: z.string(),
    name: z.string(),
    createdAt: isoDateTime,
    lastUsedAt: isoDateTime.nullable(),
    deviceType: z.string().nullable(),
    backedUp: z.boolean(),
});
export const passkeyListSchema = z.object({ passkeys: z.array(passkeySummarySchema) });
export const passkeyRenameSchema = z.object({ name: z.string().min(1).max(64) });
/** The WebAuthn option and response payloads are passed through verbatim. */
export const webauthnOptionsSchema = z.record(z.unknown());
export const webauthnResponseSchema = z.record(z.unknown());
//# sourceMappingURL=auth.js.map